import React from 'react';
import ModeCard from './ModeCard';
import BoltIcon from '@mui/icons-material/Bolt';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useUntypedTranslation } from '../../hooks/useUntypedTranslation';

const WelcomeSection = ({ username }: { username: string }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useUntypedTranslation();

  return (
    <div className="w-full">
      <div className={`mb-8 ${isMobile ? 'mb-3' : ''}`}>
        {' '}
        {/* Reduced margin-bottom on mobile */}
        <h1 style={{ fontSize: isMobile ? '1.5rem' : '2.25rem' }} className="font-bold mb-4">
          {' '}
          {t('welcome.greeting')}{' '}
          <span style={{ backgroundColor: 'var(--lemonLime)' }} className="px-2">
            {username.split(' ')[0].length > 4 ? username.split(' ')[0] : username}
          </span>
          ,
        </h1>
        <h2 style={{ fontSize: isMobile ? '1.25rem' : '1.875rem' }} className="font-bold mb-6">
          {' '}
          {t('welcome.question')}
        </h2>
        <p className={`text-lg text-gray-700 leading-relaxed ${isMobile ? 'text-base mb-4' : ''}`}>
          {' '}
          {/* Reduced margin-bottom on mobile */}
          {t('welcome.reflectionDescription')}
        </p>
        <p className={`text-lg text-gray-700 leading-relaxed ${isMobile ? 'text-base mb-4' : ''}`}>
          {' '}
          {/* Reduced margin-bottom on mobile */}
          {t('welcome.modeDescription')}
        </p>
      </div>
      {/* <Grid container spacing={isMobile ? 2 : 3}>
        <Grid item xs={12} md={6}>
          <ModeCard
            icon={<TipsAndUpdatesIcon sx={{ fontSize: isMobile ? '1.5rem' : '2rem' }} />}
            title=""
            description="Wenn du die erste Eingabe gemacht hast, gibt es eine Fast-Thinking-Modus, man kann aber auch immer in den ausführlichen Reflexionsmodus wechseln. Deine Chats sind in der History gespeichert und können jederzeit fortgesetzt werden."
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ModeCard
            icon={<BoltIcon sx={{ fontSize: isMobile ? '1.5rem' : '2rem' }} />}
            title="Fast-Thinking"
            description="Antwortzeit bis zu mehreren Min. für die erste Frage notwendig. Ergebnisse haben einen größeren Reflexionsyklus durchlaufen."
          />
        </Grid>
      </Grid> */}
    </div>
  );
};

export default WelcomeSection;
